import { SunburstChartProps } from "../../modules/dashboard/components/SunBurstChart";
import { EvolutionChartProps } from "../../modules/dashboard/components/EvolutionChart";
import { TextCardContentProps } from "../../modules/dashboard/components/TextCardContent";
import { WeatherInfoCardContentProps } from "../../modules/dashboard/components/WeatherInfoCardContent";
import { AccumulatedCertifiedEnergyProps } from "../../modules/dashboard/components/metas/AccumulatedCertifiedEnergyChart";
import { AccumulatedEnergyProps } from "../../modules/dashboard/components/metas/AccumulatedEnergyChart";
import { LossDiagramProps } from "../../modules/dashboard/components/metas/LossDiagramChart";
import { ProductivityProps } from "../../modules/dashboard/components/metas/ProductivityChart";
import {
  CardLayouts,
  CardsDisplayableColorProps,
  CardsDisplayableProps,
  ItemLayoutsConfig,
} from "../../modules/dashboard/types";
import { PortfolioData } from "../../modules/portfolio/types";
import { ParetoChartProps } from "../../modules/dashboard/components/ParetoChart";
import { TrackerChartProps } from "../../modules/dashboard/components/TrackerChart";
import { HeatmapChartProps } from "../../modules/dashboard/components/HeatmapChart";
import { EnumRopCards } from "../../modules/dashboard/models/dados-indicadores.model";

const currentDay = new Date();
const currentMonth = currentDay.getMonth() + 1;
const today = `${currentDay
  .getDate()
  .toString()
  .padStart(2, "0")}/${currentMonth
    .toString()
    .padStart(2, "0")}/${currentDay.getFullYear()}`;

export const LOADING_SYMBOL = "---";

export const prRealizadoCardId = "PrRealizado-1";
export const prRealizadoContentProps: TextCardContentProps = {
  cardId: prRealizadoCardId,
  title: "PR Realizado (%)",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  cardType: EnumRopCards.RopCard01PrRealizado,
};
export const performanceRatioCardId = "PerformanceRatio-1";
export const performanceRatioContentProps: TextCardContentProps = {
  cardId: performanceRatioCardId,
  title: "Performance Ratio",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  secondaryData: [
    {
      value: LOADING_SYMBOL,
    },
  ],
  cardType: EnumRopCards.RopCard02PerformanceRatio,
};
export const energiaGeradaCardId = "EnergiaGerada-1";
export const energiaGeradaContentProps: TextCardContentProps = {
  cardId: energiaGeradaCardId,
  title: "Energia Gerada (MWh)",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  secondaryData: [
    {
      value: LOADING_SYMBOL,
    },
  ],
  cardType: EnumRopCards.RopCard03EnergiaGerada,
};
export const valorGeradoCardId = "ValorGerado-1";
export const valorGeradoContentProps: TextCardContentProps = {
  cardId: valorGeradoCardId,
  title: "Valor Gerado (R$)",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  secondaryData: [
    {
      value: LOADING_SYMBOL,
    },
  ],
  cardType: EnumRopCards.RopCard04ValorGerado,
};
export const disponibilidadeCardId = "Disponibilidade-1";
export const disponibilidadeContentProps: TextCardContentProps = {
  cardId: disponibilidadeCardId,
  title: "Disponibilidade (%)",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  hourlyValues: [],
  cardType: EnumRopCards.RopCard05Disponibilidade,
};
export const wheaterCardId = "Ambiente-1";
export const weatherInfoProps: WeatherInfoCardContentProps = {
  cardId: wheaterCardId,
  weather: {},
  dataHoraCaptura: LOADING_SYMBOL,
  lastUpdate: new Date(),
  cardError: {},
};
export const paretoChartCardId = "Pareto-1";
export const paretoChartProps: ParetoChartProps = {
  cardId: paretoChartCardId,
  title: "Histórico de Alarmes",
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard15Pareto,
  data: {
    alarms: [],
    cardError: {},
  },
};
export const evolutionChartCardId = "EvolucaoGeracao-1";
export const evolutionChartProps: EvolutionChartProps = {
  cardId: evolutionChartCardId,
  title: `Evolução ${today}`,
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard07GraficoEvolucaoChart,
  data: {
    evolution: [],
    irradiancia: [],
    potenciaAtivaAtMinutes: [],
    cardError: {},
  },
};
export const sunburstCardId = "GeracaoPlanta-1";
export const sunburstChartProps: SunburstChartProps = {
  cardId: sunburstCardId,
  title: "Energia Gerada",
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard13EnergiaPorEquipamento,
  data: {
    cardError: {},
  },
};
export const accumulatedEnergyCardId = "EnergiaAcumulada-1";
export const accumulatedEnergyProps: AccumulatedEnergyProps = {
  cardId: accumulatedEnergyCardId,
  title: "Energia Acumulada (MWh)",
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard09EnergiaAcumulada,
  data: {
    accumulatedIdealEnergy: [],
    accumulatedGeneratedEnergy: [],
    pAccumulated: [],
    cardError: {},
  },
};
export const lossDiagramCardId = "DiagramaPerdas-1";
export const lossDiagramProps: LossDiagramProps = {
  cardId: lossDiagramCardId,
  title: "Diagrama de Perdas (MWh)",
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard10DiagramaDePerdas,
  data: {
    energiaIdeal: 0,
    perdaNoCircuito: 0,
    perdaDoTrafo: 0,
    perdaDosInversores: 0,
    perdaPorIndisponibilidade: 0,
    outrasPerdas: 0,
    energiaGerada: 0,
    cardError: {},
  },
};
export const accumulatedCertifiedEnergyCardId = "EnergiaAcumuladaCert-1";
export const accumulatedCertifiedEnergyProps: AccumulatedCertifiedEnergyProps =
{
  cardId: accumulatedCertifiedEnergyCardId,
  title: "Energia Gerada x Energia Certificada",
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard11EnergiaAcumuladaXEnergiaCertificada,
  data: {
    generatedEnergy: [],
    pFifty: 0,
    pSeventyFive: 0,
    pNinety: 0,
    pNinetyFive: 0,
    energiaCertificadaP50NormalizedValues: [],
    energiaCertificadaP75NormalizedValues: [],
    energiaCertificadaP90NormalizedValues: [],
    energiaCertificadaP95NormalizedValues: [],
    cardError: {},
  },
};
export const productivityCardId = "Produtividade-1";
export const productivityProps: ProductivityProps = {
  cardId: productivityCardId,
  title: "Produtividade",
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard12Produtividade,
  data: {
    generatedEnergy: [],
    predictedEnergy: [],
    irradiance: [],
    predictedIrradianceMonths: [],
    expectedIrradianciaAtDay: 0,
    expectedIrradianciaAtHour: 0,
    expectedEnergyAtDay: 0,
    expectedEnergyAtHour: 0,
    expectedIrradianciaNormalizedAtHour: [],
    expectedEnergyNormalizedAtHour: [],
    cardError: {},
  },
};
export const TensaoDeLinhaCardId = "TensaoDeLinha-1";
export const tensaoDeLinhaContentProps: TextCardContentProps = {
  cardId: TensaoDeLinhaCardId,
  title: "Tensão de Linha",
  value: LOADING_SYMBOL,
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard17TensaoDeLinha,
};
export const trackerChartCardId = "Tracker-1";
export const trackerChartProps: TrackerChartProps = {
  cardId: trackerChartCardId,
  title: `Tracker`,
  lastUpdate: new Date(),
  data: {
    expectedAngle: 0,
    trackers: [],
    cardError: {},
  },
};
export const heatmapChartCardId = "Heatmap-1";
export const heatmapChartProps: HeatmapChartProps = {
  cardId: heatmapChartCardId,
  title: `Potência Ativa dos Inversores`,
  lastUpdate: new Date(),
  cardType: EnumRopCards.RopCard19Heatmap,
  data: {
    inversores: [],
    cardError: {},
  },
};
export const potenciaAtivaCardId = "PotenciaAtiva-1";
export const potenciaAtivaContentProps: TextCardContentProps = {
  cardId: potenciaAtivaCardId,
  title: "Potência Ativa",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  cardType: EnumRopCards.RopCard20PotenciaAtiva,
};
export const energiaAcumuladaMWhCardId = "EnergiaAcumuladaMWh-1";
export const energiaAcumuladaMWhContentProps: TextCardContentProps = {
  cardId: energiaAcumuladaMWhCardId,
  title: "Energia Acumulada Mês",
  lastUpdate: new Date(),
  value: LOADING_SYMBOL,
  cardType: EnumRopCards.RopCard21EnergiaAcumulada,
};
export const defaultLayoutPRRealizado: CardLayouts = {
  lg: {
    cardId: prRealizadoCardId,
    x: 0,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: prRealizadoCardId,
    x: 0,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: prRealizadoCardId,
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    minW: 2,
  },
  xs: {
    cardId: prRealizadoCardId,
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    minW: 1,
  },
  xxs: { cardId: prRealizadoCardId, x: 0, y: 0, w: 1, h: 1 },
};
export const defaultLayoutPerformanceRatio: CardLayouts = {
  lg: {
    cardId: performanceRatioCardId,
    x: 2,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: performanceRatioCardId,
    x: 2,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: performanceRatioCardId,
    x: 2,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  xs: {
    cardId: performanceRatioCardId,
    x: 2,
    y: 1,
    w: 2,
    h: 1,
    minW: 2,
  },
  xxs: { cardId: performanceRatioCardId, x: 0, y: 1, w: 1, h: 1 },
};
export const defaultLayoutEnergiaGerada: CardLayouts = {
  lg: {
    cardId: energiaGeradaCardId,
    x: 4,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: energiaGeradaCardId,
    x: 4,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: energiaGeradaCardId,
    x: 0,
    y: 1,
    w: 3,
    h: 1,
    minW: 2,
  },
  xs: {
    cardId: energiaGeradaCardId,
    x: 0,
    y: 1,
    w: 2,
    h: 1,
    minW: 2,
  },
  xxs: { cardId: energiaGeradaCardId, x: 0, y: 2, w: 1, h: 1 },
};
export const defaultLayoutValorGerado: CardLayouts = {
  lg: {
    cardId: valorGeradoCardId,
    x: 6,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: valorGeradoCardId,
    x: 6,
    y: 0,
    w: 2,
    h: 1,
    minW: 3,
  },
  sm: {
    cardId: valorGeradoCardId,
    x: 3,
    y: 1,
    w: 2,
    h: 1,
    minW: 3,
  },
  xs: {
    cardId: valorGeradoCardId,
    x: 1,
    y: 2,
    w: 3,
    h: 1,
    minW: 2,
  },
  xxs: { cardId: valorGeradoCardId, x: 0, y: 4, w: 1, h: 1 },
};
export const defaultLayoutTensaoDeLinha: CardLayouts = {
  lg: {
    cardId: TensaoDeLinhaCardId,
    x: 8,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: TensaoDeLinhaCardId,
    x: 8,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: TensaoDeLinhaCardId,
    x: 5,
    y: 0,
    w: 1,
    h: 1,
    minW: 2,
  },
  xs: {
    cardId: TensaoDeLinhaCardId,
    x: 3,
    y: 0,
    w: 1,
    h: 1,
    minW: 1,
  },
  xxs: { cardId: TensaoDeLinhaCardId, x: 0, y: 3, w: 1, h: 1 },
};
export const defaultLayoutDisponibilidade: CardLayouts = {
  lg: {
    cardId: disponibilidadeCardId,
    x: 10,
    y: 0,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: disponibilidadeCardId,
    x: 8,
    y: 1,
    w: 3,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: disponibilidadeCardId,
    x: 4,
    y: 0,
    w: 1,
    h: 1,
    minW: 1,
  },
  xs: {
    cardId: disponibilidadeCardId,
    x: 1,
    y: 0,
    w: 1,
    h: 1,
    minW: 1,
  },
  xxs: { cardId: disponibilidadeCardId, x: 0, y: 5, w: 1, h: 1 },
};
export const defaultLayoutAmbiente: CardLayouts = {
  lg: {
    cardId: wheaterCardId,
    x: 0,
    y: 1,
    w: 10,
    h: 2,
    minH: 1,
    minW: 9,
  },
  md: {
    cardId: wheaterCardId,
    x: 0,
    y: 1,
    w: 7,
    h: 3,
    minH: 2,
    minW: 6,
  },
  sm: {
    cardId: wheaterCardId,
    x: 0,
    y: 2,
    w: 6,
    h: 2,
    minH: 2,
    minW: 3,
  },
  xs: {
    cardId: wheaterCardId,
    x: 0,
    y: 3,
    w: 4,
    h: 3,
    minH: 2,
    minW: 4,
  },
  xxs: {
    cardId: wheaterCardId,
    x: 0,
    y: 8,
    w: 1,
    h: 3,
    minH: 2,
    minW: 4,
  },
};
export const defaultLayoutPotenciaAtiva: CardLayouts = {
  lg: {
    cardId: potenciaAtivaCardId,
    x: 10,
    y: 1,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: potenciaAtivaCardId,
    x: 7,
    y: 2,
    w: 3,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: potenciaAtivaCardId,
    x: 1,
    y: 0,
    w: 1,
    h: 1,
    minW: 2,
  },
  xs: {
    cardId: potenciaAtivaCardId,
    x: 2,
    y: 0,
    w: 1,
    h: 1,
    minW: 1,
  },
  xxs: { cardId: potenciaAtivaCardId, x: 0, y: 6, w: 1, h: 1 },
};
export const defaultLayoutEnergiaAcumuladaMWh: CardLayouts = {
  lg: {
    cardId: energiaAcumuladaMWhCardId,
    x: 10,
    y: 2,
    w: 2,
    h: 1,
    minW: 2,
  },
  md: {
    cardId: energiaAcumuladaMWhCardId,
    x: 7,
    y: 3,
    w: 3,
    h: 1,
    minW: 2,
  },
  sm: {
    cardId: energiaAcumuladaMWhCardId,
    x: 5,
    y: 1,
    w: 1,
    h: 1,
    minW: 2,
  },
  xs: {
    cardId: energiaAcumuladaMWhCardId,
    x: 0,
    y: 2,
    w: 1,
    h: 1,
    minW: 1,
  },
  xxs: { cardId: energiaAcumuladaMWhCardId, x: 0, y: 7, w: 1, h: 1 },
};
export const defaultLayoutEvolucaoGeracao: CardLayouts = {
  lg: {
    cardId: evolutionChartCardId,
    x: 0,
    y: 3,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },
  md: {
    cardId: evolutionChartCardId,
    x: 0,
    y: 4,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },
  sm: {
    cardId: evolutionChartCardId,
    x: 0,
    y: 4,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },
  xs: {
    cardId: evolutionChartCardId,
    x: 0,
    y: 6,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },
  xxs: { cardId: evolutionChartCardId, x: 0, y: 11, w: 1, h: 3, minH: 3 },
};
export const defaultLayoutPareto: CardLayouts = {
  lg: {
    cardId: paretoChartCardId,
    x: 0,
    y: 15,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },
  md: {
    cardId: paretoChartCardId,
    x: 0,
    y: 16,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },
  sm: {
    cardId: paretoChartCardId,
    x: 0,
    y: 16,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },
  xs: {
    cardId: paretoChartCardId,
    x: 0,
    y: 27,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },
  xxs: { cardId: paretoChartCardId, x: 0, y: 34, w: 1, h: 3, minH: 3 },
};
export const defaultLayoutGeracaoPlanta: CardLayouts = {
  lg: {
    cardId: sunburstCardId,
    x: 6,
    y: 3,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },
  md: {
    cardId: sunburstCardId,
    x: 5,
    y: 4,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },
  sm: {
    cardId: sunburstCardId,
    x: 3,
    y: 4,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },
  xs: {
    cardId: sunburstCardId,
    x: 0,
    y: 9,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },
  xxs: { cardId: sunburstCardId, x: 0, y: 14, w: 1, h: 3, minH: 3 },
};
export const defaultLayoutEnergiaAcumulada: CardLayouts = {
  lg: {
    cardId: accumulatedEnergyCardId,
    x: 0,
    y: 12,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },
  md: {
    cardId: accumulatedEnergyCardId,
    x: 0,
    y: 13,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },
  sm: {
    cardId: accumulatedEnergyCardId,
    x: 0,
    y: 13,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },
  xs: {
    cardId: accumulatedEnergyCardId,
    x: 0,
    y: 15,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },
  xxs: {
    cardId: accumulatedEnergyCardId,
    x: 0,
    y: 21,
    w: 1,
    h: 3,
    minH: 3,
    minW: 4,
  },
};
export const defaultLayoutDiagramaPerdas: CardLayouts = {
  lg: {
    cardId: lossDiagramCardId,
    x: 0,
    y: 9,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },
  md: {
    cardId: lossDiagramCardId,
    x: 0,
    y: 10,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },
  sm: {
    cardId: lossDiagramCardId,
    x: 0,
    y: 10,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },
  xs: {
    cardId: lossDiagramCardId,
    x: 0,
    y: 18,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },
  xxs: {
    cardId: lossDiagramCardId,
    x: 0,
    y: 24,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },
};
export const defaultLayoutEnergiaAcumEnergiaCert: CardLayouts = {
  lg: {
    cardId: accumulatedCertifiedEnergyCardId,
    x: 6,
    y: 12,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },

  md: {
    cardId: accumulatedCertifiedEnergyCardId,
    x: 5,
    y: 13,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },

  sm: {
    cardId: accumulatedCertifiedEnergyCardId,
    x: 3,
    y: 13,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },

  xs: {
    cardId: accumulatedCertifiedEnergyCardId,
    x: 0,
    y: 21,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },

  xxs: {
    cardId: accumulatedCertifiedEnergyCardId,
    x: 0,
    y: 27,
    w: 1,
    h: 3,
    minH: 3,
  },
};
export const defaultLayoutProdutividade: CardLayouts = {
  lg: {
    cardId: productivityCardId,
    x: 6,
    y: 9,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },

  md: {
    cardId: productivityCardId,
    x: 5,
    y: 10,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },

  sm: {
    cardId: productivityCardId,
    x: 3,
    y: 10,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },

  xs: {
    cardId: productivityCardId,
    x: 0,
    y: 24,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },

  xxs: { cardId: productivityCardId, x: 0, y: 30, w: 1, h: 4, minH: 4 },
};

export const defaultLayoutTracker: CardLayouts = {
  lg: {
    cardId: trackerChartCardId,
    x: 6,
    y: 15,
    w: 6,
    h: 3,
    minH: 3,
    minW: 4,
  },

  md: {
    cardId: trackerChartCardId,
    x: 5,
    y: 16,
    w: 5,
    h: 3,
    minH: 3,
    minW: 4,
  },

  sm: {
    cardId: trackerChartCardId,
    x: 3,
    y: 16,
    w: 3,
    h: 3,
    minH: 3,
    minW: 3,
  },

  xs: {
    cardId: trackerChartCardId,
    x: 0,
    y: 30,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },

  xxs: { cardId: trackerChartCardId, x: 0, y: 37, w: 1, h: 4, minH: 4 },
};
export const defaultLayoutHeatmap: CardLayouts = {
  lg: {
    cardId: heatmapChartCardId,
    x: 0,
    y: 6,
    w: 12,
    h: 3,
    minH: 3,
    minW: 4,
  },

  md: {
    cardId: heatmapChartCardId,
    x: 0,
    y: 7,
    w: 10,
    h: 3,
    minH: 3,
    minW: 4,
  },

  sm: {
    cardId: heatmapChartCardId,
    x: 0,
    y: 7,
    w: 6,
    h: 3,
    minH: 3,
    minW: 3,
  },

  xs: {
    cardId: heatmapChartCardId,
    x: 0,
    y: 12,
    w: 4,
    h: 3,
    minH: 3,
    minW: 4,
  },

  xxs: { cardId: heatmapChartCardId, x: 0, y: 17, w: 1, h: 4, minH: 4 },
};
export const defaultLayouts: ItemLayoutsConfig = {
  id: "default",
  layouts: {
    lg: [
      defaultLayoutPRRealizado.lg,
      defaultLayoutPerformanceRatio.lg,
      defaultLayoutEnergiaGerada.lg,
      defaultLayoutValorGerado.lg,
      defaultLayoutDisponibilidade.lg,
      defaultLayoutAmbiente.lg,
      defaultLayoutEvolucaoGeracao.lg,
      defaultLayoutGeracaoPlanta.lg,
      defaultLayoutEnergiaAcumulada.lg,
      defaultLayoutDiagramaPerdas.lg,
      defaultLayoutEnergiaAcumEnergiaCert.lg,
      defaultLayoutProdutividade.lg,
      defaultLayoutPareto.lg,
      defaultLayoutTensaoDeLinha.lg,
      defaultLayoutTracker.lg,
      defaultLayoutHeatmap.lg,
      defaultLayoutPotenciaAtiva.lg,
      defaultLayoutEnergiaAcumuladaMWh.lg
    ],
    md: [
      defaultLayoutPRRealizado.md,
      defaultLayoutPerformanceRatio.md,
      defaultLayoutEnergiaGerada.md,

      defaultLayoutValorGerado.md,
      defaultLayoutDisponibilidade.md,
      defaultLayoutAmbiente.md,
      defaultLayoutEvolucaoGeracao.md,
      defaultLayoutGeracaoPlanta.md,
      defaultLayoutEnergiaAcumulada.md,
      defaultLayoutDiagramaPerdas.md,
      defaultLayoutEnergiaAcumEnergiaCert.md,
      defaultLayoutProdutividade.md,
      defaultLayoutPareto.md,
      defaultLayoutTensaoDeLinha.md,
      defaultLayoutTracker.md,
      defaultLayoutHeatmap.md,
      defaultLayoutPotenciaAtiva.md,
      defaultLayoutEnergiaAcumuladaMWh.md
    ],
    sm: [
      defaultLayoutPRRealizado.sm,
      defaultLayoutPerformanceRatio.sm,
      defaultLayoutEnergiaGerada.sm,
      defaultLayoutValorGerado.sm,
      defaultLayoutDisponibilidade.sm,
      defaultLayoutAmbiente.sm,
      defaultLayoutEvolucaoGeracao.sm,
      defaultLayoutGeracaoPlanta.sm,
      defaultLayoutEnergiaAcumulada.sm,
      defaultLayoutDiagramaPerdas.sm,
      defaultLayoutEnergiaAcumEnergiaCert.sm,
      defaultLayoutProdutividade.sm,
      defaultLayoutPareto.sm,
      defaultLayoutTensaoDeLinha.sm,
      defaultLayoutTracker.sm,
      defaultLayoutHeatmap.sm,
      defaultLayoutPotenciaAtiva.sm,
      defaultLayoutEnergiaAcumuladaMWh.sm
    ],
    xs: [
      defaultLayoutPRRealizado.xs,
      defaultLayoutPerformanceRatio.xs,
      defaultLayoutEnergiaGerada.xs,
      defaultLayoutValorGerado.xs,
      defaultLayoutDisponibilidade.xs,
      defaultLayoutAmbiente.xs,
      defaultLayoutEvolucaoGeracao.xs,
      defaultLayoutGeracaoPlanta.xs,
      defaultLayoutEnergiaAcumulada.xs,
      defaultLayoutDiagramaPerdas.xs,
      defaultLayoutEnergiaAcumEnergiaCert.xs,
      defaultLayoutProdutividade.xs,
      defaultLayoutPareto.xs,
      defaultLayoutTensaoDeLinha.xs,
      defaultLayoutTracker.xs,
      defaultLayoutHeatmap.xs,
      defaultLayoutPotenciaAtiva.xs,
      defaultLayoutEnergiaAcumuladaMWh.xs
    ],
    xxs: [
      defaultLayoutPRRealizado.xxs,
      defaultLayoutPerformanceRatio.xxs,
      defaultLayoutEnergiaGerada.xxs,
      defaultLayoutValorGerado.xxs,
      defaultLayoutDisponibilidade.xxs,
      defaultLayoutAmbiente.xxs,
      defaultLayoutEvolucaoGeracao.xxs,
      defaultLayoutGeracaoPlanta.xxs,
      defaultLayoutEnergiaAcumulada.xxs,
      defaultLayoutDiagramaPerdas.xxs,
      defaultLayoutEnergiaAcumEnergiaCert.xxs,
      defaultLayoutProdutividade.xxs,
      defaultLayoutPareto.xxs,
      defaultLayoutTensaoDeLinha.xxs,
      defaultLayoutTracker.xxs,
      defaultLayoutHeatmap.xxs,
      defaultLayoutPotenciaAtiva.xxs,
      defaultLayoutEnergiaAcumuladaMWh.xxs
    ],
  },
};
export const defaultCardsDisplayableProps: CardsDisplayableProps = {
  id: "cardDisplayableProps",
  prRealizado: {
    title: true,
    value: true,
  },
  performanceRatio: {
    title: true,
    value: true,
    idealEnergy: true,
  },
  energiaGerada: {
    title: true,
    value: true,
    ideal: true,
    percent: true,
  },
  valorGerado: {
    title: true,
    value: true,
    ideal: true,
    percent: true,
  },
  disponibilidade: {
    title: true,
    value: true,
  },
  ambiente: {
    wearher: true,
  },
  evolucaoGeracao: {
    title: true,
  },
  geracaoPlanta: {
    title: true,
  },
  energiaAcumulada: {
    title: true,
  },
  diagramaPerdas: {
    title: true,
  },
  energiaAcumEnergiaCert: {
    title: true,
  },
  produtividade: {
    title: true,
  },
  pareto: {
    title: true,
  },
  tensaoDeLinha: {
    title: true,
    tensaoDeLinhakV: true,
  },
  tracker: {
    title: true,
  },
  heatmap: {
    title: true,
  },
  potenciaAtiva: {
    title: true,
    value: true,
  },
  energiaAcumudalaMWh: {
    title: true,
    value: true,
  },
};
export const defaultCardsDisplayableColorProps: CardsDisplayableColorProps = {
  id: "cardDisplayableColorProps",
  evolucaoGeracao: {
    evolucaoColor: "#EE7D00",
    irradianciaColor: "#FAB900",
  },
  geracaoPlanta: {
    inversorColor: "#EE7D00",
    ugColor: "#FAB900",
    plantaColor: "#FADE0A",
    potenciaAtivaColor: "#1A0144",
  },
  energiaAcumulada: {
    energiaIdealColor: "#EE7D00",
    energiaGeradaColor: "#FAB900",
    P50Color: "#FADE0A",
  },
  diagramaPerdas: {
    energiaColor: "#EE7D00",
    perdaColor: "#FAB900",
  },
  energiaAcumEnergiaCert: {
    energiaGeradaColor: "#EE7D00",
    P50Color: "#FAB900",
    P75Color: "#FADE0A",
    P90Color: "#1A0144",
    P95Color: "#6D0DB8",
  },
  produtividade: {
    energiaGeradaColor: "#EE7D00",
    energiaPrevistaColor: "#FAB900",
    irradianciaColor: "#FADE0A",
    irradianciaPrevistaColor: "#1A0144",
  },
  pareto: {
    enventosQntdColor: "#EE7D00",
    porcentagemColor: "#FAB900",
  },
  tracker: {
    esperadoColor: "#EE7D00",
    trackersColor: "#FAB900",
  },
  heatmap: {
    maxColor: "#BF444C",
    minColor: "#F6EFA6",
  },
};
export const breakpoints = {
  lg: 1200,
  md: 996,
  sm: 768,
  xs: 480,
  xxs: 0,
};

export const defaultPortfolioData: PortfolioData = {
  energiaGeradaTotal: "---",
  performanceRatio: "---",
  disponibilidade: "---",
  receitaEstimada: "---",
  irradianciaMedia: "---",
  temperaturaMedia: "---",
  inversoresOffline: "---",
  inversoresBaixaEficiencia: "---",
  usinas: [],
  potenciaAtiva: "---",
  potenciaEsperada: "---",
  energiaIdeal: "---",
  energiaPrevista: "---",
  prRealizado: "---",
  prPrevisto: "---",
  energiaGeradaAtDayByHour: "---",
  irradianciaMediaByHour: "---",
  irradianciaMediaAtMinutes: "---",
  potenciaAtivaAtMinutes: "---",
};
